import { CurrentEnvironment } from "../CurrentEnvironment";

const apiUrlMap = {
  local: "http://localhost:3001",
  stg: "https://stg-xms-api.combinedcuriosity.io",
  prd: "https://prd-xms-api.combinedcuriosity.io",
} as const;

const apiUrl = apiUrlMap[CurrentEnvironment()];

export { apiUrl };
